import React, { useRef, useState } from "react";
import ReactPlayer from "react-player";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import useBodyScrollLock from "../../utils/useBodyScrollLock";
import { VideoImageZoom } from "..";

type DiscussVideoProps = {
  videos: string[];
  setShowAllVideos: React.Dispatch<React.SetStateAction<number | null>>;
  showAllVideos: number | null;
};
const DiscussVideo: React.FC<DiscussVideoProps> = ({
  videos,
  setShowAllVideos,
  showAllVideos,
}) => {
  const [playing, setPlaying] = useState(false);
  const playerRef = useRef(null);
  const play = () => setPlaying(true);
  const pause = () => setPlaying(false);
  const totalVideos = videos.length || 0;
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isLocked, toggle] = useBodyScrollLock();
  const handleClick = (index: number) => {
    setShowAllVideos(index);
    setCurrentIndex(index);
    if (typeof toggle === "function") {
      toggle();
    }
  };
  const handlePrev = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < totalVideos - 1 ? prevIndex + 1 : prevIndex
    );
  };

  const handleClose = () => {
    if (typeof toggle === "function") {
      toggle();
    }
    setShowAllVideos(null);
  };
  let hash1;
  let hash2;
  return (
    <div className="flex w-full bg-white mb-8">
      {videos && videos.length > 4 ? (
        <div
          className="grid grid-rows-3 grid-flow-col grid-cols-3 w-full lg:h-[400px] h-[300px]"
          // key={currentIndex * 2}
        >
          {videos?.map((video, index) => {
            const inputString = video;
            const ipfsHashes = inputString.match(/\bQm\w{44}\b/g);

            if (ipfsHashes) {
              [hash1, hash2] = ipfsHashes;
            }

            return (
              index === 0 && (
                <div
                  className="row-span-full col-span-2 border relative overflow-hidden cursor-pointer"
                  key={index * 2}
                >
                  <ReactPlayer
                    ref={playerRef}
                    key={index}
                    url={ipfsGatewayImage(hash1!)}
                    controls={true}
                    playing={playing}
                    onPlay={play}
                    onPause={pause}
                    volume={1}
                    muted={true}
                    light={ipfsGatewayImage(hash2!)}
                    width="100%"
                    height="100%"
                  />
                </div>
              )
            );
          })}
          {videos &&
            videos?.slice(1, 4).map((video, index) => {
              const inputString = video;
              const ipfsHashes = inputString.match(/\bQm\w{44}\b/g);

              if (ipfsHashes) {
                [hash1, hash2] = ipfsHashes;
              }

              return (
                <div
                  className="h-full relative overflow-hidden"
                  key={index * 3}
                  onClick={() => handleClick(index + 1)}
                >
                  <div className="border w-full h-full relative cursor-pointer">
                    <ReactPlayer
                      ref={playerRef}
                      key={index}
                      url={ipfsGatewayImage(hash1!)}
                      controls={true}
                      playing={playing}
                      onPlay={play}
                      onPause={pause}
                      volume={1}
                      muted={true}
                      light={ipfsGatewayImage(hash2!)}
                      width="100%"
                      height="100%"
                    />
                  </div>
                  {index === videos?.slice(1, 4).length - 1 && (
                    <div
                      className="w-full h-full text-white text-center bg-[rgba(0,0,0,0.7)] top-0 right-0 absolute font-Poppins text-2xl items-center flex justify-center cursor-pointer"
                      key={index * 4}
                      onClick={() => setShowAllVideos(4)}
                    >
                      <p>+ {videos?.length - 4}</p>
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      ) : videos && videos?.length > 3 ? (
        <div className="flex flex-col w-full lg:h-[350px] h-[250px]">
          {videos?.map((video, index) => {
            const inputString = video;
            const ipfsHashes = inputString.match(/\bQm\w{44}\b/g);

            if (ipfsHashes) {
              [hash1, hash2] = ipfsHashes;
            }
            return (
              index === 0 && (
                <div className="flex w-full" key={index + 21}>
                  <div
                    className="w-full border relative lg:h-[250px] h-[128px] overflow-hidden cursor-pointer"
                    onClick={() => handleClick(index)}
                  >
                    <ReactPlayer
                      ref={playerRef}
                      key={index}
                      url={ipfsGatewayImage(hash1!)}
                      controls={true}
                      playing={playing}
                      onPlay={play}
                      onPause={pause}
                      volume={1}
                      muted={true}
                      light={ipfsGatewayImage(hash2!)}
                      width="100%"
                      height="100%"
                    />
                  </div>
                </div>
              )
            );
          })}
          <div className="grid grid-flow-row overflow-hidden col-span-3 grid-cols-3 w-full">
            {videos?.map((video, index) => {
              const inputString = video;
              const ipfsHashes = inputString.match(/\bQm\w{44}\b/g);

              if (ipfsHashes) {
                [hash1, hash2] = ipfsHashes;
              }
              return (
                index !== 0 && (
                  <div key={index * 81} className="w-full">
                    <div className="relative w-full lg:h-[90%] lg:max-h-[90%] h-[100%] max-h-[120px] overflow-hidden">
                      <div
                        className="border-2 w-full h-full cursor-pointer"
                        onClick={() => handleClick(index)}
                      >
                        <ReactPlayer
                          ref={playerRef}
                          key={index}
                          url={ipfsGatewayImage(hash1!)}
                          controls={true}
                          playing={playing}
                          onPlay={play}
                          onPause={pause}
                          volume={1}
                          muted={true}
                          light={ipfsGatewayImage(hash2!)}
                          width="100%"
                          height="100%"
                        />
                      </div>
                    </div>
                  </div>
                )
              );
            })}
          </div>
        </div>
      ) : (
        <div className="flex w-full">
          {videos?.length === 1
            ? videos.map((video, index) => {
                const inputString = video;
                const ipfsHashes = inputString.match(/\bQm\w{44}\b/g);

                if (ipfsHashes) {
                  [hash1, hash2] = ipfsHashes;
                }

                return (
                  <div
                    className="flex w-full lg:max-h-[350px] lg:h-[350px] h-[290px]"
                    key={index + 44}
                  >
                    <div
                      className="w-full relative cursor-pointer h-auto overflow-hidden"
                      onClick={() => handleClick(index)}
                    >
                      <ReactPlayer
                        ref={playerRef}
                        key={index}
                        url={ipfsGatewayImage(hash1!)}
                        controls={true}
                        playing={playing}
                        onPlay={play}
                        onPause={pause}
                        volume={1}
                        muted={true}
                        light={ipfsGatewayImage(hash2!)}
                        width="100%"
                        height="100%"
                      />
                    </div>
                  </div>
                );
              })
            : videos?.length === 2
            ? videos?.map((video, index) => {
                const inputString = video;
                const ipfsHashes = inputString.match(/\bQm\w{44}\b/g);

                if (ipfsHashes) {
                  [hash1, hash2] = ipfsHashes;
                }
                return (
                  <div className="flex w-full bg-white" key={index * 99}>
                    <div
                      className="h-[250px] cursor-pointer flex justify-between gap-1 w-full overflow-hidden border relative"
                      onClick={() => handleClick(index)}
                    >
                      <ReactPlayer
                        ref={playerRef}
                        key={index}
                        url={ipfsGatewayImage(hash1!)}
                        controls={true}
                        playing={playing}
                        onPlay={play}
                        onPause={pause}
                        volume={1}
                        muted={true}
                        light={ipfsGatewayImage(hash2!)}
                        width="100%"
                        height="100%"
                      />
                    </div>
                  </div>
                );
              })
            : videos?.length === 3 && (
                <div className="flex w-full">
                  {videos.map((video, index) => {
                    const inputString = video;
                    const ipfsHashes = inputString.match(/\bQm\w{44}\b/g);

                    if (ipfsHashes) {
                      [hash1, hash2] = ipfsHashes;
                    }

                    return (
                      index === 0 && (
                        <div
                          className="flex w-full max-h-[400px]"
                          key={index * 20}
                        >
                          <div
                            className="w-full border relative lg:h-[400px] h-[308px] overflow-hidden cursor-pointer"
                            onClick={() => handleClick(index)}
                          >
                            <ReactPlayer
                              ref={playerRef}
                              key={index}
                              url={ipfsGatewayImage(hash1!)}
                              controls={true}
                              playing={playing}
                              onPlay={play}
                              onPause={pause}
                              volume={1}
                              muted={true}
                              light={ipfsGatewayImage(hash2!)}
                              width="100%"
                              height="100%"
                            />
                          </div>
                        </div>
                      )
                    );
                  })}
                  <div className="grid grid-rows-2 h-auto w-full overflow-hidden">
                    {videos?.map((video, index) => {
                      const inputString = video;
                      const ipfsHashes = inputString.match(/\bQm\w{44}\b/g);

                      if (ipfsHashes) {
                        [hash1, hash2] = ipfsHashes;
                      }

                      return (
                        index !== 0 && (
                          <div
                            className="flex w-full overflow-hidden relative h-[198px]"
                            key={index + 33}
                          >
                            <div
                              className="w-full flex-1 border flex cursor-pointer"
                              onClick={() => handleClick(index)}
                            >
                              <ReactPlayer
                                ref={playerRef}
                                key={index}
                                url={ipfsGatewayImage(hash1!)}
                                controls={true}
                                playing={playing}
                                onPlay={play}
                                onPause={pause}
                                volume={1}
                                muted={true}
                                light={ipfsGatewayImage(hash2!)}
                                width="100%"
                                height="100%"
                              />
                            </div>
                          </div>
                        )
                      );
                    })}
                  </div>
                </div>
              )}
        </div>
      )}
      {videos && showAllVideos !== null && totalVideos > 0 && isLocked && (
        <VideoImageZoom
          selectedVideos={videos}
          playing={playing}
          playerRef={playerRef}
          allMediaUrls={videos}
          currentIndex={currentIndex}
          handlePrev={handlePrev}
          handleNext={handleNext}
          play={play}
          pause={pause}
          totalMedias={totalVideos}
          handleClose={handleClose}
        />
      )}
    </div>
  );
};

export default DiscussVideo;
